var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xzj"},[_c('van-button',{staticStyle:{"width":"100%"},attrs:{"type":"info","square":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")]),_c('div',{staticClass:"model",attrs:{"id":"modelShow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }